export const MoveToTopIcon = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 14.2344H12.3809L14.8203 11.7949V4.30176H15.8203V12.209L12.7949 15.2344H0V4.30176H1V14.2344Z"
        fill="white"
      />
      <path d="M8.6709 13.0352H7.0752V9.71875H8.6709V13.0352Z" fill="white" />
      <path d="M4.35156 11.708H2.75586V8.3916H4.35156V11.708Z" fill="white" />
      <path d="M12.9912 11.708H11.3955V8.3916H12.9912V11.708Z" fill="white" />
      <path
        d="M6.67871 7.72852H5.08301V4.41211H6.67871V7.72852Z"
        fill="white"
      />
      <path d="M10.665 7.72852H9.06934V4.41211H10.665V7.72852Z" fill="white" />
      <path
        d="M10.0498 2.60156H5.77051L7.91016 0L10.0498 2.60156Z"
        fill="white"
      />
    </svg>
  );
};
